export default __webpack_public_path__ + "static/1170-392ac0c4e49fd296254b5f10be72e3b7.gif";